import { useMutation } from '@tanstack/react-query';
import { updateUserTodayGroupBy } from 'shared/services/backend-api';
import { TodayGroupBy } from 'shared/types/sorting-mode';

export const useUpdateTodayGroupByMutation = () =>
  useMutation({
    mutationFn: async (groupBy: TodayGroupBy) =>
      updateUserTodayGroupBy(groupBy),
  });
